<template>
  <div class="mb-12">
    <h2 v-if="subject.teaser" v-html="subject.teaser"></h2>
    <h1 v-if="subject.title" v-html="subject.title"></h1>

    <img v-if="subject.image" :src="`${subject.image}?${random_value}`" class="w-full mt-6">

    <div class="blocks mt-4">
      <block-index></block-index>
    </div>

    <subject-navigation :prev_subject="prev_subject"
                        :next_subject="next_subject"
                        @handle_click="handle_subject_link($event)"
                        ></subject-navigation>

    <pre>
      <!--
      {{ subjects.filter( s => s.topic_id == subject.topic_id ) }}
      -->
    </pre>

    <pre v-if="debug" class="mt-24">
    {{ subject }}
    </pre>

  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import SubjectNavigation from '../components/subject_navigation.vue'
import BlockIndex from '../components/block_index.vue'

export default {
  data() {
    return {
      debug: false
    }
  },
  methods: {
    handle_subject_link( id ) {
      this.$router.push(`/subject/${id}`)
    }

  },
  mounted() {
    // Open all links in new Tab or window
    this.$nextTick( function() {
      document.querySelectorAll('.blocks a').forEach(function(link) {
        if (link.host !== window.location.host) {
          link.target = "_blank"
        }
      })
    })
  },
  computed: {
    ...mapState(['subjects']),
    ...mapGetters(['selected_subject']),
    subject() {
      return this.selected_subject(this.$route.params.id)
    },
    topic_subjects() {
      return this.subjects.filter( s => s.topic_id == this.subject.topic_id )
    },
    next_subject() {
      let current_position = this.topic_subjects.indexOf( this.subject )
      let next_pos = this.topic_subjects[ current_position + 1 ]
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      if( next_pos ) return next_pos
      return null
    },
    prev_subject() {
      let current_position = this.topic_subjects.indexOf( this.subject )
      if( current_position > 0 ) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        return this.topic_subjects[ current_position - 1 ]
      }
      return null
    },
    random_value: () => Math.random()
  },
  components: {
    SubjectNavigation,
    BlockIndex
  }
}
</script>